import React, { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { PublicRoute } from '../components/PublicRoute';

// Auth Components
import SignIn from '../client/sign-in';
import SignUp from '../client/sign-up';
import ForgotPassword from '../client/forgot-password';
import ResetPassword from '../client/reset-password';
import PartnerSignIn from '../partner/sign-in';
import PartnerSignUp from '../partner/sign-up';
import PartnerForgotPassword from '../partner/forgot-password';
import PartnerResetPassword from '../partner/reset-password';
import PublicLinkPage from '../partner/public/PublicLinkPage';

// Route Components
import ClientRoutes from './clientRoutes';
import PartnerRoutes from './partnerRoutes';

type RouterProps = {};

const RootRouter: FC<RouterProps> = React.memo(() => {
  return (
    <Routes>
      {/* Default route redirect to client sign-in */}
      <Route path="/" element={<Navigate to="/client/sign-in" replace />} />

      {/* Client Authentication Routes */}
      <Route
        path="/client/sign-in"
        element={
          <PublicRoute>
            <SignIn />
          </PublicRoute>
        }
      />

      <Route
        path="/client/sign-up"
        element={
          <PublicRoute>
            <SignUp />
          </PublicRoute>
        }
      />

      <Route
        path="/client/forgot-password"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />

      <Route
        path="/client/reset-password"
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />

      {/* Partner Authentication Routes */}
      <Route
        path="/partner/sign-in"
        element={
          <PublicRoute>
            <PartnerSignIn />
          </PublicRoute>
        }
      />

      <Route
        path="/partner/sign-up"
        element={
          <PublicRoute>
            <PartnerSignUp />
          </PublicRoute>
        }
      />

      <Route
        path="/partner/forgot-password"
        element={
          <PublicRoute>
            <PartnerForgotPassword />
          </PublicRoute>
        }
      />

      <Route
        path="/partner/reset-password"
        element={
          <PublicRoute>
            <PartnerResetPassword />
          </PublicRoute>
        }
      />

      {/* Public Link Page - accessible to everyone */}
      <Route path="/partner/public/:idLink" element={<PublicLinkPage />} />

      {/* Client Routes */}
      <Route path="/client/*" element={<ClientRoutes />} />

      {/* Partner Routes */}
      <Route path="/partner/*" element={<PartnerRoutes />} />

      {/* 404 Redirect */}
      <Route path="*" element={<Navigate to="/client/sign-in" replace />} />
    </Routes>
  );
});

RootRouter.displayName = 'RootRouter';

export default RootRouter;
